import '../components/_form-spinner';
import StickySidebar from 'sticky-sidebar';
import '../components/_product-list';
import '../components/_product-size-variation';
import '../components/_product-gallery-position'
import '../components/_product-bundle-position'
import productGallery from "../components/_product-gallery-position";
import productBundle from "../components/_product-bundle-position";

const breakpoints = {
    sm : '576',
    md : '768',
    lg : '992'
}

/* ************************************
            Sticky Sidebar
************************************ */

let siteHeader = document.querySelector('[js-site-header]');

let sidebar = null;

export const makeSidebarSticky = () => {
    sidebar = new StickySidebar('[js-sidebar-wrapper]', {
        containerSelector: '[js-sidebar-container]',
        innerWrapperSelector: '[js-sidebar-inner]',
        topSpacing: siteHeader.offsetHeight,
        bottomSpacing: 30,
        minWidth: breakpoints.lg,
    });
}

function destroySidebarSticky()
{
    sidebar.destroy();
}

/* Init sticky sidebar */
if (window.innerWidth >= breakpoints.lg) {
    const image = document.querySelector('[js-product-gallery] .woocommerce-product-gallery__wrapper img');

    if (image) {
        image.addEventListener('load', () => {
            makeSidebarSticky();
        });
    }

    setTimeout(() => {
        if (!sidebar) {
            makeSidebarSticky();
        }
    }, 2000);
}

/* ************************************
Init default position of image Galleru
************************************ */

productGallery.defaultPosition();

/* ************************************
Init default position of bundle
************************************ */

productBundle.defaultPosition();


/* ******************************************
  Add or remove things if desktop or mobile
****************************************** */

let rtime;
let timeout = false;
let delta = 200;

// SET device
let device = null;
if (window.innerWidth >= breakpoints.lg) {
    device = 'desktop';
} else {
    device = 'mobile';
}

$(window).resize(function() {
    rtime = new Date();
    if (timeout === false) {
        timeout = true;
        setTimeout(resizeend, delta);
    }
});

function resizeend()
{
    if (new Date() - rtime < delta) {
        setTimeout(resizeend, delta);
    } else {
        timeout = false;

        if (window.innerWidth >= breakpoints.lg && device !== 'desktop') {
            swicthToDesktop();
        }
        if (window.innerWidth < breakpoints.lg && device !== 'mobile') {
            swicthToMobile();
        }
    }
}

function swicthToDesktop()
{
    productGallery.moveToDesktop();
    makeSidebarSticky();
    device = 'desktop';
}

function swicthToMobile()
{
    productGallery.moveToMobile();
    destroySidebarSticky();
    device = 'mobile';
}

window.addEventListener('load', function (e) {
    let zoomIcon = document.querySelector('.woocommerce-product-gallery__trigger');
    if (zoomIcon) {
        zoomIcon.innerHTML = '<i class="icon icon-search"></i>';
    }
});
